import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { PageBase } from 'src/app/page.base';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { CostCenterService } from 'src/app/services/cost-center.service';
import { ToasterService } from 'src/app/services/toaster.service';
import { ICostCenter } from 'src/app/interfaces/cost-center';

@Component({
  selector: 'cost-center-form',
  templateUrl: './cost-center-form.component.html',
  styleUrls: ['cost-center-form.component.scss']
})
export class CostCenterFormComponent extends PageBase implements OnInit {

  @Output() closeModal = new EventEmitter();
  costCenter = {} as ICostCenter;

  addressTypes = [];

  unitForm: FormGroup;
  companyId: string;
  loading = false;

  constructor(
    private costCenterService: CostCenterService,
    private toastService: ToasterService
  ) { super(); }

  ngOnInit() {
    this.loadForm();
    this.getAddressTypes();
  }

  chargeCostCenterForm(data) {
    this.costCenter = data;
    this.loadForm();
  }

  getAddressTypes() {
    this.costCenterService.getAddressTypes().then(res => this.addressTypes = res);
  }

  loadForm() {
    this.unitForm = new FormGroup({
      name: new FormControl(this.costCenter.name, Validators.required),
      cnpj: new FormControl(this.costCenter.cnpj, Validators.required),
      code: new FormControl(this.costCenter.code, Validators.required),
      addressTypesId: new FormControl(this.costCenter.addressTypesId, Validators.required)
    });
  }

  checkErrorField(key) {
    const formField = this.unitForm.controls[key];
    return formField.invalid && formField.touched;
  }

  public cleanForm(formGroup: FormGroup): boolean {
    Object.keys(formGroup.controls).forEach((key) => formGroup.get(key).setValue(formGroup.get(key).value.trim()));
    return true;
  }

  formSubmit(form) {
    const { id, companyId } = this.costCenter;
    const { value } = form;
    const data = { ...value, companyId };

    if (!this.checkCNPJ(this.unitForm.value.cnpj)) {
      this.unitForm.controls.cnpj.setErrors({ invalid: true });
    } else if (id) {
      this.updateCostCenter(id, data);
    } else {
      this.saveCostCenter(data);
    }
  }

  saveCostCenter(data) {
    this.loading = true;
    this.costCenterService.createCostCenters(data).then(() => {
      this.successCallback();
    }, (err) => {
      this.handleError(err);
      this.loading = false;
    });
  }

  updateCostCenter(id, data) {
    this.loading = true;
    this.costCenterService.updateCostCenters(id, data).then(() => {
      this.successCallback();
    }, (error) => {
      this.handleError(error);
      this.loading = false;
    });
  }

  successCallback() {
    this.emitMessage('Sucesso', 'Unidade salva com sucesso.');
    this.closeModal.emit(true);
    this.loading = false;
  }

  handleError(error) {
    const { status } = error;

    if (status === 409) {
      this.emitMessage('Oops!',
        'Não foi possível salvar. Código da unidade já existente.');
    } else {
      this.closeModal.emit(true);
      this.emitMessage('Erro',
        'Não foi possível salvar. Entre em contato com o suporte.');
    }
  }

  emitMessage(title, message) {
    this.toastService.info(
      title, message, true, 2400);
  }

}
